import { useLocalStorage, type RemovableRef } from '@vueuse/core'

import type { ListView } from './types'

/**
 * The cards-or-table choice of one list, remembered between visits.
 *
 * It is a preference rather than a filter, so it stays out of the URL: a shared link
 * should open the list someone else's way, not force your layout on them. `key` names
 * the list (`'marketplace'`), and the storage key is namespaced from it so two lists
 * never collide.
 *
 * A widget whose two views are not cards and a table (a chart or its table) names its own
 * union as the type argument and passes its default: `useViewMode<'chart' | 'table'>(key,
 * 'chart')`. Without the type argument the view would narrow to the literal passed.
 */
export function useViewMode(
  key: string,
  initial?: ListView
): RemovableRef<ListView>
export function useViewMode<View extends string>(
  key: string,
  initial: NoInfer<View>
): RemovableRef<View>
export function useViewMode(key: string, initial: string = 'cards') {
  return useLocalStorage(`view:${key}`, initial)
}
